var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"d-flex justify-content-center align-items-end pb-9",class:_vm.$style.footer,style:({
    backgroundImage: ("url(" + (_vm.assets.FooterBackground.default) + ")"),
  })},[_c('JoinButton',{attrs:{"href":_vm.assets.LINK_TO_CREATOR}},[_vm._v("\n    "+_vm._s(_vm.$t('join.section.footer.cta.label'))+"\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }